/**
 * Deploy-specific configuration whitelists.
 */
export default [
    'inviteUrl',
    'deeplinking',
    'prejoinConfig'
];
